/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaginationData
 */
export interface PaginationData {
    /**
     * Total number of items matching the search criteria.
     * @type {number}
     * @memberof PaginationData
     */
    total: number;
}

/**
 * Check if a given object implements the PaginationData interface.
 */
export function instanceOfPaginationData(value: object): value is PaginationData {
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function PaginationDataFromJSON(json: any): PaginationData {
    return PaginationDataFromJSONTyped(json, false);
}

export function PaginationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginationData {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
    };
}

export function PaginationDataToJSON(json: any): PaginationData {
    return PaginationDataToJSONTyped(json, false);
}

export function PaginationDataToJSONTyped(value?: PaginationData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
    };
}

